<template>
  <div>
    <template v-if="isBot">
      <LayoutBot>
        <slot/>
      </LayoutBot>
    </template>

    <template v-else-if="isWidget">
      <LayoutWidget>
        <slot/>
      </LayoutWidget>
    </template>

    <template v-else-if="isApp">
      <LayoutBookApp>
        <slot/>
      </LayoutBookApp>
    </template>

    <template v-else-if="isFacebook">
      <LayoutWidget>
        <slot/>
      </LayoutWidget>
    </template>

    <template v-else>
      <LayoutWeb>
        <slot/>
      </LayoutWeb>
    </template>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'default'
})

useSiteHead()


const route = useRoute()
const layoutStore = useLayoutStore()

const isBot = computed(() => {
  return layoutStore.layout === 'bot' || route.query.layout === 'bot'
})

const isWidget = computed(() => {
  return layoutStore.layout === 'widget' || route.query.layout === 'widget'
})

const isApp = computed(() => {
  return layoutStore.layout === 'app' || route.query.layout === 'app'
})

const isFacebook = computed(() => {
  return layoutStore.layout === 'facebook'
})
</script>
